import { styled } from '@mui/material/styles';
import { DatagridConfigurable } from 'shared/react-admin/Datagrids';
import { getColumnStyle } from 'utils';

export const DatagridConfigurableStyled = styled(DatagridConfigurable)(({ theme }) => ({
  '& .column-date': getColumnStyle(156),
  '& .column-referral': getColumnStyle(106),
  '& .column-expenseId': getColumnStyle(87),
  '& .column-expenseType': getColumnStyle(141),
  '& .column-articleName': getColumnStyle(128),
  '& .column-subarticleName': getColumnStyle(155),
  '& .column-merchantAccountAmount': {
    ...getColumnStyle(204),
    textAlign: 'right',
  },
  '& .column-merchantAccountCurrency': getColumnStyle(148),
  '& .column-selectedCurrencyAmount': {
    ...getColumnStyle(174),
    textAlign: 'right',
  },

  '& .column-comment': getColumnStyle(280),
  '& .column-approver': getColumnStyle(243),

  '& .RaDatagrid-rowCell, .RaDatagrid-headerCell': {
    border: `1px solid ${theme.palette.divider}`,
  },
}));
